
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/esg-guide/blog/make",
      function () {
        return require("private-next-pages/esg-guide/blog/make/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/esg-guide/blog/make"])
      });
    }
  